import { render } from "./UeCoalDtEditView.vue?vue&type=template&id=77f65b9f&scoped=true"
import script from "./UeCoalDtEditView.vue?vue&type=script&lang=js"
export * from "./UeCoalDtEditView.vue?vue&type=script&lang=js"

import "./UeCoalDtEditView.vue?vue&type=style&index=0&id=77f65b9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f65b9f"]])

export default __exports__